import { createContext, ReactNode, useContext } from "react";

import { useFilterUtilCategory } from "./filter-util-category.hook";

const FilterUtilCategoryContext = createContext(
  {} as ReturnType<typeof useFilterUtilCategory>
);
export function useFilterUtilCategoryContext() {
  return useContext(FilterUtilCategoryContext);
}

interface FilterUtilCategoryProviderProps {
  children: ReactNode;
}
export function FilterUtilCategoryProvider({
  children,
}: FilterUtilCategoryProviderProps) {
  return (
    <FilterUtilCategoryContext.Provider value={useFilterUtilCategory()}>
      {children}
    </FilterUtilCategoryContext.Provider>
  );
}
